module.exports = __webpack_public_path__ + "static/section8-img3-6b605175c7957d5f644916341da3d521.png";